import ApiBYM from './config/api/ApiBYM'
import httpErrorMessage from '../utils/httpErrorMessage'
import httpstatus from '../utils/httpstatus'

export default {
    
    async ObtenerProductos(payload) {
        try {
            
            let response = await ApiBYM.get('/v1/productos',payload)

            if(response.status != httpstatus.SUCCESS && response.data){
                var errors = null
                if(response.data.data){
                    errors = Object.keys(response.data.data).map(key => response.data.data[key]).join("");
                }
                throw new Error( (response.data.message) + "\n" + (errors ? errors : httpErrorMessage.DEFAULT_ERROR))
            }else if(response.status == 0){
                throw new Error(httpErrorMessage.CONECTION_ERROR)
            }

            return response.data

        } catch (error) {
            throw new Error(error.message)
        }
    },
    async CrearProducto(data) {
        try {
            
            let response = await ApiBYM.post('/v1/productos',data)

            if(response.status != httpstatus.SUCCESS && response.data){
                var errors = null
                if(response.data.data){
                    errors = Object.keys(response.data.data).map(key => response.data.data[key]).join("");
                }
                throw new Error( (response.data.message) + "\n" + (errors ? errors : httpErrorMessage.DEFAULT_ERROR))
            }else if(response.status == 0){
                throw new Error(httpErrorMessage.CONECTION_ERROR)
            }

            return response.data

        } catch (error) {
            throw new Error(error.message)
        }
    },
    async EditarProducto(data) {
        try {
            
            let response = await ApiBYM.put('/v1/productos',data)

            if(response.status != httpstatus.SUCCESS && response.data){
                var errors = null
                if(response.data.data){
                    errors = Object.keys(response.data.data).map(key => response.data.data[key]).join("");
                }
                throw new Error( (response.data.message) + "\n" + (errors ? errors : httpErrorMessage.DEFAULT_ERROR))
            }else if(response.status == 0){
                throw new Error(httpErrorMessage.CONECTION_ERROR)
            }

            return response.data

        } catch (error) {
            throw new Error(error.message)
        }
    },
    async EliminarProducto(data) {
        try {
            
            let params = {producto_id:data}
            let response = await ApiBYM.delete('/v1/productos',params)

            if(response.status != httpstatus.SUCCESS && response.data){
                var errors = null
                if(response.data.data){
                    errors = Object.keys(response.data.data).map(key => response.data.data[key]).join("");
                }
                throw new Error( (response.data.message) + "\n" + (errors ? errors : httpErrorMessage.DEFAULT_ERROR))
            }else if(response.status == 0){
                throw new Error(httpErrorMessage.CONECTION_ERROR)
            }

            return response.data

        } catch (error) {
            throw new Error(error.message)
        }
    },
}